import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
// Fix for default marker icon in React Leaflet
// In a real app, you'd import these properly or use custom icons
const icon = L.icon({
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});
export function SitesMap() {
  // Center on New York area as shown in screenshot
  const position: [number, number] = [40.7128, -74.006];
  return <div className="h-full w-full min-h-[400px] relative z-0" data-id="element-3829" data-mp="2ot4zyvhfbwf6">
      <MapContainer center={position} zoom={9} scrollWheelZoom={false} className="h-full w-full rounded-lg" style={{
      height: '100%',
      width: '100%',
      minHeight: '400px'
    }} data-id="element-3830" data-mp="zhckcf8y2x40">
        <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" data-id="element-3831" data-mp="jx2ezrdv4db" />
        <Marker position={position} icon={icon} data-id="element-3832" data-mp="a9glo6j0d08p">
          <Popup data-id="element-3833" data-mp="ab9rjjlsrgfn">
            Broadway Construction Group <br data-id="element-3834" data-mp="ebk9lumv5xav" /> Main Site
          </Popup>
        </Marker>
        {/* Add a few more markers to simulate 5 sites */}
        <Marker position={[40.75, -73.98]} icon={icon} data-id="element-3835" data-mp="j9ltuiw102nx" />
        <Marker position={[40.8, -73.95]} icon={icon} data-id="element-3836" data-mp="jc7zue39qa41" />
        <Marker position={[40.65, -73.95]} icon={icon} data-id="element-3837" data-mp="oaj66eucu2hi" />
        <Marker position={[40.72, -74.05]} icon={icon} data-id="element-3838" data-mp="t8kp8zrs61sz" />
      </MapContainer>

      {/* Custom zoom controls overlay if needed, but Leaflet has defaults */}
    </div>;
}